import { colors } from "../../utils/const";

export const styless = {
  dropBox: {
    color: "#344054",
    borderRadius: "8px",
    textAlign: "center",
    padding: { xs: "4px 8px", md: "8px 20px " },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  menuItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: colors.navy_blue,
    fontSize: 15,
    textDecoration: "none",
    transition: "1s",
    "&:hover": {
      color: colors.navy_blue,
    },
  },
  menuSeparator: {
    width: "100%",
    my: { xs: 0.8, md: 1 },
    borderBottom: `1px solid ${colors.light_grey}`,
  },
};
